
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      if (requireAdmin) {
        // Admin kontrolü - localStorage'dan kontrol et
        const adminLoggedIn = localStorage.getItem('adminLoggedIn');
        setIsAuthenticated(adminLoggedIn === 'true');
      }
      setIsChecking(false);
    };

    checkAuth();
  }, [requireAdmin]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <i className="ri-loader-4-line text-4xl text-[#FCD34D] animate-spin"></i>
          <p className="text-gray-400 mt-4">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
